export const POST_UPDATE = 'POST_UPDATE';
export const POST_SET_MANY = 'POST_UPDATE_MANY';
export const POST_REMOVED = 'POST_REMOVED';
export const UPDATE_LATEST_POST_FOR_BLOCK = 'UPDATE_LATEST_POST_FOR_BLOCK';
export const PORTFOLIO_POST_SET_MANY = 'PORTFOLIO_POST_SET_MANY';
export const UPDATE_COMMENT_COUNT = 'UPDATE_COMMENT_COUNT';
